<template>
  <div class="fullscreen-images" v-if="showImage">
        <vueper-slides ref="vueper" class="images" :arrows="false" :bullets="false" :dragging-distance="70">
            <vueper-slide 
                v-for="(image, id) in images" 
                :key="id" class='image' 
                :image="image"                                
            />            
        </vueper-slides>
        <ShowImage :showImage="showImage" gradient @click="showImage = false; $emit('hide')"/>
    </div>
</template>

<script>
import { VueperSlides, VueperSlide } from 'vueperslides'
import 'vueperslides/dist/vueperslides.css'
import ShowImage from "@/patterns/ShowImage.vue";
export default {
    name:'FullscreenImages',
    components: { VueperSlides, VueperSlide, ShowImage },
    props : {
        showImage:Boolean,
        images:Array
    }
}
</script>

<style lang="scss">
    .fullscreen-images {
        .images {
            height:100%;
        }
        .vueperslides__inner {
            height:inherit;
        }
        .vueperslides__parallax-wrapper {
            height:inherit;
            padding-bottom:0 !important;
        }
    }   
    .vueperslides__arrows {
        position:absolute;
        bottom:20px;
        width:100%;
        height:30px;
        box-sizing: border-box;
        button {
            margin:0;
            padding:0;            
            .icon {
                background: rgba(#0B0B0B, 0.7);
            }
            &.vueperslides__arrow--prev {
                left:20px;
            }
            &.vueperslides__arrow--next {
                right:20px;
            }
        }
    }
</style>
<style lang="scss" scoped>
    .fullscreen-images {
        position:fixed;
        top:0;
        left:0;
        width:100%;
        height:100%;
        z-index: 4;
    }
</style>